export type FeedbackType = "success" | "info" | "warning" | "error";

export interface FeedbackMessage {
  title: string;
  description?: string;
  type?: FeedbackType;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void | Promise<void>;
  };
}

export function notify(message: FeedbackMessage) {
  globalThis.window?.dispatchEvent(
    new CustomEvent<FeedbackMessage>("ronda:feedback", { detail: message }),
  );
}
